import { lazy } from 'react';
import { DemoManifest } from '../types';

const NespressoDemo = lazy(() => import('./NespressoDemo'));

export const nespressoDemo: DemoManifest = {
  id: 'nespresso',
  name: 'Nespresso',
  description: 'Coffee pod recycling with gamification',
  logo: '/assets/images/logos/nespresso.svg',
  color: '#986f38',
  component: NespressoDemo,
  features: {
    gamification: true,
    loyalty: true,
    cashRewards: false,
    discountCoupons: false,
  },
};

// Context
export * from './context/NespressoContext';
export { NespressoProvider } from './context/NespressoContext';

// Views
export {
  NespressoDemoView as DemoView,
  NespressoTakebackWelcomeView as WelcomeView,
  NespressoBeforeStartView as BeforeStartView,
  NespressoScanView as ScanView,
  NespressoOfferView as OfferView,
  NespressoConfirmationView as ConfirmationView,
  ShareableAchievementView,
  VideoShareView,
  RewardSelectionView,
  SummaryView,
} from './views';

// Components
export {
  NespressoDemoControls as DemoControls,
  NespressoMilestoneCelebration as MilestoneCelebration,
} from './components';
